<template>
	<div>
        <div class="columns">
            <div class="column">
                <p class="title is-6 mt-2 mb-1">Angle Settings</p>
                <div class="up-input-group">
                    <up-numberinput
                    v-model="angle_lines.angle_start"
                    size="sm"
                    label="Angle Start"
                    ></up-numberinput>
                    <up-numberinput
                    v-model="angle_lines.angle_between"
                    size="sm"
                    label="Angle Between Lines"
                    ></up-numberinput>
                </div>    
            </div>
            <div class="column">
                <p class="title is-6 mt-2 mb-1">Line Styles</p>
                <div class="up-input-group">
                    <up-textinput
                        v-model="angle_lines.line_styles.bg_color"
                        size="sm"
                        label="Line Color"
                    ></up-textinput>
                    <up-numberinput
                        v-model="angle_lines.line_length"
                        size="sm"
                        label="Line Length"
                        labelIcon="mdi mdi-alpha-l-box-outline"
                    ></up-numberinput>
                    <up-numberinput
                        v-model="angle_lines.line_stroke_width"
                        size="sm"
                        label="Line Width"
                        labelIcon="mdi mdi-alpha-w-box-outline"
                    ></up-numberinput>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <p class="title is-6 mt-2 mb-1">Pivot Styles</p>
                <div class="up-input-group">
                    <up-numberinput
                        v-model="angle_lines.pivot_radius"
                        size="sm"
                        label="Pivot Radius"
                    ></up-numberinput>
                </div>
            </div>
            <div class="column">
                <style-editor
                    title="Box"
                    show_width 
                    show_height
                    v-model="angle_lines.box_styles"
                ></style-editor>
            </div>
        </div>    
        <show-angle-lines :angle_lines="angle_lines"></show-angle-lines>
    </div>
</template>
<script>
import StyleEditor from '@/components/Common/StyleEditor/StyleEditor'
import { defaultAngleLinesValue } from "./utils";
import ShowAngleLines from '@/components/Question/AngleLines/ShowAngleLines'
import UpTextinput from "@/components/UI/Inputs/UpTextinput";
import UpNumberinput from '@/components/UI/Inputs/UpNumberinput'

export default {
	name : 'set-angle-lines',
	components : {
		StyleEditor,
        ShowAngleLines,
        UpTextinput,
        UpNumberinput,
	},
	props : {
		value : {
			type : Object,
		}
	},
	data(){
		return {
            angle_lines: this.value ? this.value : defaultAngleLinesValue(),
		}
	},
    watch: {
        angle_lines: {
        handler: function (new_val) {
            this.$emit("input", new_val);
        },
        deep: true,
        },
        value: {
        handler: function (new_val) {
            this.angle_lines = new_val;
        },
        deep: true,
        },
    },
}
</script>